import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { AlertCircle, ArrowRight } from 'lucide-react'

export function CodigoUsadoPage() {
  const { uuid } = useParams<{ uuid: string }>()
  const location = useLocation()
  const navigate = useNavigate()
  const codigoUsado = (location.state as { codigoUsado?: string })?.codigoUsado || ''

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white dark:from-gray-900 dark:to-gray-950 flex items-center justify-center p-4">
      <Card className="max-w-md w-full border-0 shadow-lg">
        <CardContent className="p-8 text-center space-y-6">
          <div className="rounded-full bg-amber-100 dark:bg-amber-900/30 p-4 w-fit mx-auto">
            <AlertCircle className="h-12 w-12 text-amber-600" />
          </div>

          <div>
            <h2 className="text-xl font-bold">Código ya utilizado</h2>
            <p className="text-muted-foreground text-sm mt-2">
              El código <span className="font-mono font-bold">{codigoUsado}</span> ya fue canjeado anteriormente.
            </p>
          </div>

          <div className="space-y-3">
            <Button
              className="w-full bg-teal-800 hover:bg-teal-900 text-white"
              onClick={() => navigate(`/qr/${uuid}/solicitar`, { state: { codigoUsado } })}
            >
              Solicitar nuevo código <ArrowRight className="ml-2 h-4 w-4" />
            </Button>

            <Button
              variant="outline"
              className="w-full"
              onClick={() => navigate(`/qr/${uuid}`)}
            >
              Intentar con otro código
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
